module.exports = __webpack_public_path__ + "img/pr-3.6919d24d.png";